import { render, staticRenderFns } from "./StopList.vue?vue&type=template&id=2033b9f2&scoped=true&"
import script from "./StopList.vue?vue&type=script&lang=js&"
export * from "./StopList.vue?vue&type=script&lang=js&"
import style0 from "./StopList.vue?vue&type=style&index=0&id=2033b9f2&lang=scss&scoped=true&"
import style1 from "./StopList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2033b9f2",
  null
  
)

export default component.exports